export const Endpoints = {
  login: "/administrators/login",
  ssoLogin: "/administrators/sso-login",
  logout: "/logout",
  changePassword: "/change-password",
  salesData: (startDate: string, endDate: string) => { return `/sales?startDate=${startDate}&endDate=${endDate}` },


  // Catalog Version Control
  catalogVersion: {
    "list": (page: number, limit: number, search: string, status: string) => { return `/version/catalog?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (status ? `&status=${status}` : '') },
    "clone": "/version/catalog/clone",
    "edit": (versionId: string) => { return `/version/catalog/${versionId}` },
    "delete": (versionId: string) => { return `/version/catalog/${versionId}` },
    "approve": (versionId: number) => { return `/version/catalog/${versionId}/approve` },
    "forceUpdate": (versionId: number) => { return `/version/catalog/${versionId}/force-update` },
    "auditList": (page: number, limit: number, search: string, versionId: string, recordType: string, product: string, regions: Array<any>) => { return `/auditlogs?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (versionId ? `&catalogVersionId=${versionId}` : '') + (recordType ? `&recordType=${recordType}` : '') + (product ? `&productId=${product}` : '') + (regions ? `&regions=${regions}` : []) },
    "export": (version_Id: string) => { return `/export-audit-log?catalogVersionId=${version_Id}` },
    "catalogExport": (version_Id: string) => { return `/data/migrate/export?catalogVersionId=${version_Id}` },
    // "catalogExport": "/data/migrate/export",
    "catalogImport": "/data/migrate/import",
    "activate": "/version/catalog/activate",
    exportPricebook: (version_Id: string, regions: string) => { return `/export-price-book?catalogVersionId=${version_Id}&regions=${regions}` },
    "import": "/version/catalog/import",
    "crossCatalog": (environment: string) => { return `/version/catalog/cross?environment=${environment}` },
  },

  // Product
  product: {
    "list": (page: number, limit: number, searchProduct: string, version_Id: string) => { return `/products?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (searchProduct ? `&search=${searchProduct}` : '') },
    "add": "/products",
    "update": (product_id: number) => { return `/products/${product_id}` },
    "delete": (product_id: number, page: number) => { return `/products/${product_id}?page=${page}` },
    "changeStatus": (product_id: number) => { return `/products/${product_id}/status` },
    "mapping": "/products/mapping",
    "export": (version_Id: string) => { return `/export-fields?catalogVersionId=${version_Id}` },
    category: {
      "list": (page: number, limit: number, product_id: string, version_Id: string, interactive: string, mull: string) => { return `/categories?page=${page}&limit=${limit}&productId=${product_id}&catalogVersionId=${version_Id}` + (interactive ? `&isInteractiveTool=${interactive}` : '') + (mull ? `&isMullConfig=${mull}` : '') },
      "add": "/categories",
      categorie: (page: number, limit: number, product_status: string) => { return `page=${page}&limit${limit}` + (product_status ? `&Status=${product_status}` : '') },
      "update": (category_id: number) => { return `/categories/${category_id}` },
      "delete": (category_id: number, page: number) => { return `/categories/${category_id}?page=${page}` },
      "changeStatus": (category_id: number) => { return `/categories/${category_id}/status` },
      "changeOrder": "/categories/position",
    },
    field: {
      "list": (page: number, limit: number, search: string, product_id: string, category_id: string, version_Id: string, interactive: string, mull: string, isAlter?: number) => { return `/fields?page=${page}&limit=${limit}&productId=${product_id}&categoryId=${category_id}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (interactive ? `&isInteractiveTool=${interactive}` : '') + (mull ? `&isMullConfig=${mull}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
      "add": "/fields",
      "update": (field_id: number) => { return `/fields/${field_id}` },
      "delete": (field_id: number, page: number, version_Id: string) => { return `/fields/${field_id}?page=${page}&catalogVersionId=${version_Id}` },
      "detail": (field_id: number) => { return `/fields/${field_id}` },
      "changeStatus": (field_id: number) => { return `/fields/${field_id}/status` },
      "changeAutoFill": (field_id: number) => { return `/fields/${field_id}/autofill` },
      "changeOrder": "/fields/position",
      "disabledContract": (field_id: number) => { return `/fields/${field_id}/contract` },
      "appStatus": (field_id: number) => { return `/fields/${field_id}/apps` },
      "enableProduct": (field_id: number) => { return `/fields/${field_id}/product` },
      "enableCommon": (field_id: number) => { return `/fields/${field_id}/common` },
      "mapping": (field_id: number) => { return `/fields/${field_id}/mapping` },
      "productMapping": "/fields/product-mapping",
      "enableHide": (field_id: number) => { return `/fields/${field_id}/hide` },
      "mapField": (field_id: number) => { return `/fields/${field_id}/map-field` },
      "repeatField": (field_id: number) => { return `/fields/${field_id}/repeat` },
    },
  },

  // Choices
  choice: {
    "list": (page: number, limit: number, search: string, version_Id: string, productId: string) => { return `/choices?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (productId ? `&productIds=${productId}` : '') },
    "add": "/choices",
    "details": (choices_id: number) => { return `/choices/${choices_id}` },
    "update": (choices_id: number, page: number) => { return `/choices/${choices_id}?page=${page}` },
    "delete": (product_id: number, page: number) => { return `/choices/${product_id}?page=${page}` },
    "changeStatus": (product_id: number) => { return `/choices/${product_id}/status` },
    "clone": "/choices/clone",
    "imgUpload": (version_Id: string) => { return `/choices/image-upload?catalogVersionId=${version_Id}` },
    "compare": (sourceVersion_Id: string, targetVersion_Id: string) => { return `/choices-compare?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` },
  },

  // Specifications
  specification: {
    "list": (page: number, limit: number, version_Id: string, searchProduct: string, isAlter?: number) => { return `/specifications?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (searchProduct ? `&search=${searchProduct}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
    "add": "/specifications",
    "update": (specification_id: number) => { return `/specifications/${specification_id}` },
    "delete": (specification_id: number, page: number, version_Id: string) => { return `/specifications/${specification_id}?page=${page}&catalogVersionId=${version_Id}` },
  },

  // Additional Info
  additionalInfo: {
    section: {
      "list": (page: number, limit: number, version_Id: string) => { return `/sections?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` },
      "add": "/sections",
      "update": (section_id: number) => { return `/sections/${section_id}` },
      "delete": (section_id: number) => { return `/sections/${section_id}` },
      "changeStatus": (section_id: number) => { return `/sections/${section_id}/status` },
      "changeOrder": "/sections/position",
    },
    field: {
      "list": (page: number, limit: number, section_id: string, version_Id: string, isAlter?: number) => { return `/additional-info/fields?page=${page}&limit=${limit}&sectionId=${section_id}&catalogVersionId=${version_Id}` + (isAlter ? `&isAlter=${isAlter}` : '') },
      "add": "/additional-info/fields",
      "update": (field_id: number) => { return `/additional-info/fields/${field_id}` },
      "changeStatus": (field_id: number) => { return `/additional-info/fields/${field_id}/status` },
      "delete": (field_id: number, page: number, version_Id: string) => { return `/additional-info/fields/${field_id}?page=${page}&catalogVersionId=${version_Id}` },
      "changeOrder": "/additional-info/fields/position",
      "appStatus": (field_id: number) => { return `/additional-info/fields/${field_id}/apps` },
    }
  },

  specialCondition: {
    "list": (page: number, limit: number, version_Id: string, search: string, product, isAlter?: number) => { return `/special-conditions?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (product ? `&productId=${product}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
    "add": "/special-conditions",
    "update": (id: number) => { return `/special-conditions/${id}` },
    "delete": (id: number) => { return `/special-conditions/${id}` },
  },

  // Price Version Control
  priceVersion: {
    "list": "/version/price",
    "clone": "/version/price/clone",
    "edit": (versionId: string) => { return `/version/price/${versionId}` },
    "delete": (versionId: string) => { return `/version/price/${versionId}` },
  },

  // Packages
  packages: {
    "list": "/packages",
    "add": "/packages",
    "update": (package_id: number) => { return `/system/${package_id}` },
    "delete": (id: number, section_Type) => { return `/system/${id}/${section_Type}` },
  },

  // Promo Banner
  packageInfo: {
    "list": "/package/info",
    "add": "/package/info",
    "update": (package_id: number) => { return `/package/info/${package_id}` },
    "delete": (id: number) => { return `/package/info/${id}` },
  },

  // Regions
  regions: {
    "list": (page: number, limit: number, version_Id: string) => { return `/regions?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` },
    "add": "/region/packages",
    "states": "/region/states",
    "update": (package_id: number) => { return `/system/${package_id}` },
    "delete": (package_id: number) => { return `/system/${package_id}` },
  },

  // Tax
  tax: {
    "list": "/taxes",
    "add": "/taxes",
    "update": (tax_id: string) => { return `/taxes/${tax_id}` },
    "delete": (tax_id: string) => { return `/taxes/${tax_id}` }
  },

  // cron
  cron: {
    "list": "/crons",
    "add": "/crons",
    "update": (jobId: string) => { return `/crons/${jobId}` },
    "delete": (jobId: string) => { return `/crons/${jobId}` }
  },

  banks: {
    "list": "/finance-banks",
    "add": "/finance-banks",
    "update": (id: string) => { return `/finance-banks/${id}` },
    "delete": (id: string) => { return `/finance-banks/${id}` },
    "status": (id: number) => { return `/finance-banks/${id}/status` },
    "changeOrder": "/finance-banks/position",
  },

  // App version
  appVersion: {
    "getVersion": "/version/check",
    "updateVersion": "/version"
  },

  /////////////////////////////Base Price Configurator Endpoints//////////////////////////////////
  base: {
    pricing: (version_Id: string, page: number, limit: number, searchPrice: string, product: any, regions: Array<any>, isAlter?: number) => { return `/base-prices?catalogVersionId=${version_Id}&page=${page}&limit=${limit}` + (searchPrice ? `&search=${searchPrice}` : '') + (product ? `&productId=${product}` : '') + (regions ? `&regions=${regions}` : []) + (isAlter ? `&isAlter=${isAlter}` : '') },
    addPrice: "/base-prices",
    updatePrice: (regionalBasePriceId: number) => { return `/base-prices/${regionalBasePriceId}` },
    delete: (basePriceConfigId: number, page: number) => { return `/base-prices/${basePriceConfigId}?page=${page}` },
    commonData: "/common/data",
    basePrices: "/base-prices",
    exportbasePrices: (version_Id: string) => { return `/export-base-prices?catalogVersionId=${version_Id}` },
    getFields: (page: number, limit: number, product_id: string, category_id: string) => { return `/fields?page=${page}&limit=${limit}&productId=${product_id}&categoryId=${category_id}` },
    changePrice: '/change-base-prices',
    comparePrice: (sourceVersion_Id: string, targetVersion_Id: string) => { return `/compare-base-prices?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` },
    importBasePrice: '/import-base-prices'
  },

  ////////////////////////////Options Pricing Configurator/////////////////////////////////////////
  option: {
    pricing: (version_Id: string, page: number, limit: number, searchOptionName: string, product, regions: Array<any>, isAlter?: number) => { return `/option-prices?catalogVersionId=${version_Id}&page=${page}&limit=${limit}` + (searchOptionName ? `&search=${searchOptionName}` : '') + (product ? `&productId=${product}` : '') + (regions ? `&regions=${regions}` : []) + (isAlter ? `&isAlter=${isAlter}` : '') },
    addOptionPricing: "/option-prices",
    updatedOptionPricing: (optionPricing_id: string) => { return `/option-prices/${optionPricing_id}` },
    deleteOptionPrice: (optionPricing_id: string) => { return `/option-prices/${optionPricing_id}` },
    exportoptionPrices: (version_Id: string) => { return `/export-option-prices?catalogVersionId=${version_Id}` },
    changestatus: (optionPricing_id: number) => { return `/toggle-option-prices/${optionPricing_id}` },
    changePrice: '/change-option-prices',
    comparePrice: (sourceVersion_Id: string, targetVersion_Id: string) => { return `/compare-option-prices?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` },
    importOptionPrice: '/import-option-prices'
  },

  additionalFee: {
    'list': (page: number, limit: number, version_Id: string, search: string, isAlter?: number) => { return `/additional-fee?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
    "add": "/additional-fee",
    "update": (additionalFee_Id: number) => { return `/additional-fee/${additionalFee_Id}` },
    "delete": (additionalFee_Id: number) => { return `/additional-fee/${additionalFee_Id}` },
    "export": (version_Id: string) => { return `/export-additional-fee?catalogVersionId=${version_Id}` },
    "comparePrice": (sourceVersion_Id: string, targetVersion_Id: string) => { return `/compare-additional-fee?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` }
  },

  // Orders
  orders: {
    sales: {
      "list": (page: number, limit: number, search: string, salesRepEmail: string, orderStatus: string, orderType: string, signingType: string, startDate, endDate, organizationType: string, regions) => { return `/orders?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (salesRepEmail ? `&salesRepEmail=${salesRepEmail}` : '') + (orderStatus ? `&orderStatus=${orderStatus}` : '') + (orderType ? `&orderType=${orderType}` : '') + (signingType ? `&signingType=${signingType}` : '') + (startDate ? `&startDate=${startDate}` : '') + (endDate ? `&endDate=${endDate}` : '') + (organizationType ? `&organizationType=${organizationType}` : '') + (regions ? `&regions=${regions}` : '') },
      "taskList": (appointment_id: number, orderId: number) => { return `/orders/tasks?dbAppointmentId=${appointment_id}&orderId=${orderId}` },
      "processTask": "/orders/replay-tasks",
      "salesRep": "/orders/sales-rep",
      "uploadOrder": "/orders/upload",
      "exportPDF": (appointment_id: number, order_id: number, task_name: string) => { return `/orders/download/pdf?dbAppointmentId=${appointment_id}&orderId=${order_id}&taskName=${task_name}` },
      "priceBreakDown": (appointment_id: number, order_id: number) => { return `/orders/download/price-breakdown?dbAppointmentId=${appointment_id}&orderId=${order_id}` },
      "crmOrderId ": "/update-crmorder",
    },
    measure: {
      "list": (page: number, limit: number, search: string, salesRepEmail: string, orderStatus: string, startDate, endDate, organizationType: string) => { return `/measure/orders?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (salesRepEmail ? `&salesRepEmail=${salesRepEmail}` : '') + (orderStatus ? `&orderStatus=${orderStatus}` : '') + (startDate ? `&startDate=${startDate}` : '') + (endDate ? `&endDate=${endDate}` : '') + (organizationType ? `&organizationType=${organizationType}` : '') },
      "taskList": (measureAppointmentId: number, measureOrderId: number) => { return `/measure/orders/tasks?measureAppointmentId=${measureAppointmentId}&measureOrderId=${measureOrderId}` },
      "processTask": "/measure/orders/replay-tasks",
      "salesRep": "/measure/orders/sales-rep",
      "uploadOrder": "/measure/orders/upload",
      "exportPDF": (measureAppointment_id: number, measureOrder_id: number, task_name: string) => { return `/orders/download/file?crmMeasureAppointmentId=${measureAppointment_id}&orderId=${measureOrder_id}&taskName=${task_name}` }
    },
    customer: {
      "list": (page: number, limit: number, search: string, salesRepEmail: string, orderStatus: string, startDate, endDate) => { return `/customer/orders?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (salesRepEmail ? `&salesRepEmail=${salesRepEmail}` : '') + (orderStatus ? `&orderStatus=${orderStatus}` : '') + (startDate ? `&startDate=${startDate}` : '') + (endDate ? `&endDate=${endDate}` : '') },
      "details": (orderId: number) => { return `/customer/orders/detail?orderId=${orderId}` },
      "salesRep": "/orders/sales-rep",
      "exportPDF": (appointment_id: number, order_id: number, task_name: string) => { return `/customer/orders/download/pdf?dbAppointmentId=${appointment_id}&orderId=${order_id}&taskName=${task_name}` }
    },
  },

  // Discount
  discount: {
    coupon: {
      "list": (page: number, limit: number, search: string, couponType: string) => { return `/coupons?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (couponType ? `&couponType=${couponType}` : '') },
      "add": "/coupons",
      "details": (coupon_id: number) => { return `/coupons${coupon_id}` },
      "update": (coupon_id: number, page: number) => { return `/coupons/${coupon_id}?page=${page}` },
      "delete": (coupon_id: number, page: number) => { return `/coupons/${coupon_id}?page=${page}` },
      "changeStatus": (coupon_id: number) => { return `/coupons/${coupon_id}/status` },
      "updatePackages": (coupon_id) => { return `/coupons/${coupon_id}/packages` },
    },
    monthlyPromo: {
      "list": "/promos",
      "add": "/promos",
      "delete": "/promos",
      "addBack": (promoId) => { return `/promos/${promoId}/add-back` },
      "status": (promoId) => { return `/promos/${promoId}/status` },
      "version": "/promos/version"
    },
    promoBananer: {
      "uploadBanner": "/promo/banners",
      "getBannerList": "/promo/banners",
      "delete": (id: number) => { return `/promo/banners/${id}` }
    }
  },

  common: {
    "Data": "/common/data",
    "choices": (version_Id: string) => { return `/choices?catalogVersionId=${version_Id}` },
    "fields": (product_id: string, version_Id: string) => { return `/fields?&productId=${product_id}&catalogVersionId=${version_Id}` },
    "products": "/products",
    "packages": "/packages",
    "regions": "/regions",
  },

  admin: {
    "administrator": (page, limit, search: string) => { return `/administrators?page=${page}&limit=${limit}&search=${search}` },
    "addAdministrator": "/administrators",
    "deleteAdministrator": (id: string) => { return `/administrators/${id}` },
    "setPassword": (id: string) => { return `/administrators/${id}/set-password` },
  },

  takeoff: {
    "productlist": (page: number, limit: number, searchProduct: string, version_Id: string, isTakeOff: boolean) => { return `/products?page=${page}&limit=${limit}&catalogVersionId=${version_Id}&isTakeOff=${isTakeOff}` + (searchProduct ? `&search=${searchProduct}` : '') },
    category: {
      "list": (page: number, limit: number, product_id: string, version_Id: string) => { return `/takeoff/categories?page=${page}&limit=${limit}&productId=${product_id}&catalogVersionId=${version_Id}` },
      "add": "/takeoff/categories",
      "update": (category_id: number) => { return `/takeoff/categories/${category_id}` },
      "delete": (category_id: number) => { return `/takeoff/categories/${category_id}` },
      "changeStatus": (category_id: number) => { return `/takeoff/categories/${category_id}/status` },
      "changeOrder": "/takeoff/categories/position",
    },
    field: {
      "list": (page: number, limit: number, search: string, product_id: string, category_id: string, version_Id: string, isAlter?: number) => { return `/takeoff/fields?page=${page}&limit=${limit}&productId=${product_id}&categoryId=${category_id}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
      "add": "/takeoff/fields",
      "update": (field_id: number) => { return `/takeoff/fields/${field_id}` },
      "delete": (field_id: number) => { return `/takeoff/fields/${field_id}` },
      "changeStatus": (field_id: number) => { return `/takeoff/fields/${field_id}/status` },
      "changeOrder": "/takeoff/fields/position",
      "mapping": (field_id: number) => { return `/takeoff/fields/${field_id}/mapping` },
      "detail": (field_id: number) => { return `/takeoff/fields/${field_id}` },
      "productMapping": "/takeoff/fields/product-mapping",
      "mapField": (field_id: number) => { return `/takeoff/fields/${field_id}/map-field` },
      "mapTakeoffField": (field_id: number) => { return `/takeoff/fields/${field_id}/map-takeoff-field` },
    },
    "takeOffCatalog": "/common/takeoff-catalog",
    keys: {
      "list": (page: number, limit: number, version_Id: string, search: string) => { return `/keys?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') },
      "add": "/keys",
      "update": (id: number) => { return `/keys/${id}` },
      "changeStatus": (id: number) => { return `/keys/${id}/status` },
      "delete": (id: number) => { return `/keys/${id}` },
    },
    "compare": (sourceVersion_Id: string, targetVersion_Id: string) => { return `/takeoff-compare?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` },
  },

  // House Inspection
  houseInspections: {
    categories: {
      "list": (page: number, limit: number, version_Id: string) => { return `/house-inspections/categories?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` },
      "add": "/house-inspections/categories",
      "update": (section_id: number) => { return `/house-inspections/categories/${section_id}` },
      "delete": (section_id: number) => { return `/house-inspections/categories/${section_id}` },
      "changeStatus": (section_id: number) => { return `/house-inspections/categories/${section_id}/status` },
      "changeOrder": "/house-inspections/categories/position",
    },
    fields: {
      "list": (page: number, limit: number, section_id: string, version_Id: string, isAlter?: number) => { return `/house-inspections/fields?page=${page}&limit=${limit}&categoryId=${section_id}&catalogVersionId=${version_Id}` + (isAlter ? `&isAlter=${isAlter}` : '') },
      "add": "/house-inspections/fields",
      "update": (field_id: number) => { return `/house-inspections/fields/${field_id}` },
      "delete": (field_id: number, page: number) => { return `/house-inspections/fields/${field_id}?page=${page}` },
      "changeStatus": (field_id: number) => { return `/house-inspections/fields/${field_id}/status` },
      "changeOrder": "/house-inspections/fields/position",
    }
  },

  fieldsCheck: (version_Id: string) => { return `/fields-check?catalogVersionId=${version_Id}` },

  interactiveTool: {
    category: {
      "list": (page: number, limit: number, product_id: string, version_Id: string) => { return `/tool/categories?page=${page}&limit=${limit}&productId=${product_id}&catalogVersionId=${version_Id}` },
      "add": "/tool/categories",
      "update": (category_id: number) => { return `/tool/categories/${category_id}` },
      "delete": (category_id: number) => { return `/tool/categories/${category_id}` },
      "changeStatus": (category_id: number) => { return `/tool/categories/${category_id}/status` },
      "changeOrder": "/tool/categories/position",
    },
    field: {
      "list": (page: number, limit: number, search: string, product_id: string, category_id: string, version_Id: string, isAlter?: number) => { return `/tool/fields?page=${page}&limit=${limit}&productId=${product_id}&categoryId=${category_id}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
      "add": "/tool/fields",
      "update": (field_id: number) => { return `/tool/fields/${field_id}` },
      "delete": (field_id: number) => { return `/tool/fields/${field_id}` },
      "changeStatus": (field_id: number) => { return `/tool/fields/${field_id}/status` },
      "changeOrder": "/tool/fields/position",
      "repeatField": (field_id: number) => { return `/tool/fields/${field_id}/repeat` },
    },
  },

  asbestos: {
    'list': (page: number, limit: number, version_Id: string, search: string, isAlter?: number) => { return `/asbestos?page=${page}&limit=${limit}&catalogVersionId=${version_Id}` + (search ? `&search=${search}` : '') + (isAlter ? `&isAlter=${isAlter}` : '') },
    "add": "/asbestos",
    "update": (id: number) => { return `/asbestos/${id}` },
    "delete": (id: number) => { return `/asbestos/${id}` },
  },

  compare: {
    "catalogCompare": (sourceVersion_Id: string, targetVersion_Id: string) => { return `/compare/catalog?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` },
    "catalogCompareExport": (sourceVersion_Id: string, targetVersion_Id: string) => { return `/compare/catalog/export?sourceVersionId=${sourceVersion_Id}&targetVersionId=${targetVersion_Id}` }
  },

  users: {
    "sales": (page: number, limit: number, search: string, currentVersion: string) => { return `/users/sales?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (currentVersion ? `&currentVersion=${currentVersion}` : '') },
    "measure": (page: number, limit: number, search: string, currentVersion: string) => { return `/users/measure?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '') + (currentVersion ? `&currentVersion=${currentVersion}` : '') },
    "exportSales": (search: string, currentVersion: string) => {
      let queryParams = [];

      if (search) {
        queryParams.push(`search=${encodeURIComponent(search)}`);
      }

      if (currentVersion) {
        queryParams.push(`currentVersion=${encodeURIComponent(currentVersion)}`);
      }

      return `/users/sales/export` + (queryParams.length ? `?${queryParams.join('&')}` : '');
    },
    "exportMeasure": (search: string, currentVersion: string) => {
      let queryParams = [];

      if (search) {
        queryParams.push(`search=${encodeURIComponent(search)}`);
      }

      if (currentVersion) {
        queryParams.push(`currentVersion=${encodeURIComponent(currentVersion)}`);
      }

      return `/users/measure/export` + (queryParams.length ? `?${queryParams.join('&')}` : '');
    }
  }

}